export const GROUP_AUTHORIZATION_KEY = 'GROUP_AUTHORIZATION'
export const GROUP_EXPIRATION_KEY = 'GROUP_EXPIRATION'
export const GROUP_ORDER_CODE_KEY = 'GROUP_ORDER_CODE'

export function getGroupAuthorization () {
  return localStorage.getItem(GROUP_AUTHORIZATION_KEY)
}

export function setGroupAuthorization (authorization, expiration) {
  localStorage.setItem(GROUP_AUTHORIZATION_KEY, authorization)
  if (expiration) {
    localStorage.setItem(GROUP_EXPIRATION_KEY, expiration)
  }
}

export function removeGroupAuthorization () {
  localStorage.removeItem(GROUP_AUTHORIZATION_KEY)
  localStorage.removeItem(GROUP_EXPIRATION_KEY)
}



// WEBPACK FOOTER //
// ./src/group/utils/auth.js